import { FC } from 'react';

type FinancialWheelOptionProps = {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
};

/** Checkbox row for financial-intelligence product wheels. */
export const FinancialWheelOption: FC<FinancialWheelOptionProps> = ({ label, checked, onChange }) => (
  <label
    className={`inline-flex cursor-pointer items-center gap-2 text-sm font-open-sans ${
      checked ? 'text-primary-300' : 'text-[#4D4D4D]'
    }`}
  >
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="h-4 w-4 rounded border-[#E4EEF1] text-primary-300 accent-primary-300"
    />
    {label}
  </label>
);
